import * as Type from 'library/ts/utilities/modules/Type';

/**
 * @description Processes cust_params as per GAM documentation
 * @see {@link https://support.google.com/admanager/answer/1068325}
 * @param {string} custParams
 * @param {boolean} encode
 * @return {string}
 */
export const processCustParams = ( custParams: string, encode: boolean = true ): string => {
	interface IListItem {
		searchValue: RegExp;
		replaceValue: string;
	}

	// sanity check
	if ( Type.isString( custParams ) === false ) return custParams;

	// Decode list
	const decodeList: IListItem[] = [
		{
			searchValue: new RegExp( /%3D/g ),
			replaceValue: '='
		},
		{
			searchValue: new RegExp( /%26/g ),
			replaceValue: '&'
		},
		{
			searchValue: new RegExp( /%2C/g ),
			replaceValue: ','
		}
	];

	// Encode list
	const encodeList: IListItem[] = [
		{
			searchValue: new RegExp( /=/g ),
			replaceValue: '%3D'
		},
		{
			searchValue: new RegExp( /&/g ),
			replaceValue: '%26'
		},
		{
			searchValue: new RegExp( /,/g ),
			replaceValue: '%2C'
		}
	];

	// List to use based on flag passed in
	const list: IListItem[] = ( encode === true ? encodeList : decodeList );

	// loop over items
	list.forEach(
		( item ) => {
			// execute replacement
			custParams = String( custParams ).replace( item.searchValue, item.replaceValue );
		}
	);

	return custParams;
};

/**
 * @description Returns correlator value for ad calls
 * @returns {string}
 */
export const getCorrelator = (): string => {
	let n = String( Math.round( 1000000000000000 + Math.random() * 9000000000000000 ) );
	if ( n.length < 16 ) {
		while ( n.length < 16 ) n += '0';
	}
	if ( n.length > 16 ) {
		n = n.substr( 0, 17 );
	}
	return n;
};